module.exports = __webpack_public_path__ + "img/maxime-pro.869be9d6.jpg";